/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Tlm_2Inputs */

const en_svc_ai_voice_agents_tlm_2 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inference_gate`)
};

const ar_svc_ai_voice_agents_tlm_2 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بوابة الاستدلال`)
};

const bn_svc_ai_voice_agents_tlm_2 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inference_gate`)
};

const de_svc_ai_voice_agents_tlm_2 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inference_gate`)
};

const es_svc_ai_voice_agents_tlm_2 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`puerta_inferencia`)
};

const fr_svc_ai_voice_agents_tlm_2 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`porte_inférence`)
};

const pt_svc_ai_voice_agents_tlm_2 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inference_gate`)
};

const zh_svc_ai_voice_agents_tlm_2 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推理门`)
};

const tr_svc_ai_voice_agents_tlm_2 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`çıkarım_kapısı`)
};

const ru_svc_ai_voice_agents_tlm_2 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ворота_вывода`)
};

const pl_svc_ai_voice_agents_tlm_2 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bramka_wnioskowania`)
};

/**
* | output |
* | --- |
* | "inference_gate" |
*
* @param {Svc_Ai_Voice_Agents_Tlm_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_tlm_2 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Tlm_2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Tlm_2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_tlm_2(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_tlm_2(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_tlm_2(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_tlm_2(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_tlm_2(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_tlm_2(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_tlm_2(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_tlm_2(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_tlm_2(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_tlm_2(inputs)
	return en_svc_ai_voice_agents_tlm_2(inputs)
});
export { svc_ai_voice_agents_tlm_2 as "svc_ai-voice-agents_tlm_2" }